import { post } from './api'
import {
  transformEmissionHotelBatchResponse,
  transformEmissionPropertyBatchResponse,
} from './co2/helpers'

import type {
  PostHotelBatchCarbonEmissionParams,
  PostPropertyBatchCarbonEmissionParams,
  TransformedHotelBatchCarbonEmissionResponse,
  TransformedPropertyBatchCarbonEmissionResponse,
} from './co2/types'

const adjustHeaders = (xhr: XMLHttpRequest) => {
  xhr.setRequestHeader('api-key', process.env.CO2_API_KEY)
}

export const postHotelBatchCarbonEmission = async (
  data: PostHotelBatchCarbonEmissionParams
) =>
  post<TransformedHotelBatchCarbonEmissionResponse>(
    `${process.env.CO2_API_BASE_URL}/co2/hotel/batch`,
    data,
    adjustHeaders
  ).then(transformEmissionHotelBatchResponse)

export const postPropertyBatchCarbonEmission = async (
  data: PostPropertyBatchCarbonEmissionParams
) =>
  post<TransformedPropertyBatchCarbonEmissionResponse>(
    `${process.env.CO2_API_BASE_URL}/co2/property/batch`,
    data,
    adjustHeaders
  ).then(transformEmissionPropertyBatchResponse)
